export const HIT_BACKOFFICE_LIST = 'HIT_BACKOFFICE_LIST';
export const GET_BACKOFFICE_LIST = 'GET_BACKOFFICE_LIST';

export const HIT_BO_COMPANY_CREATE = 'HIT_BO_COMPANY_CREATE';
export const HIT_BO_COMPANY_UPDATE = 'HIT_BO_COMPANY_UPDATE';
export const HIT_BO_COMPANY_DELETE = 'HIT_BO_COMPANY_DELETE';

// list subscription
export const HIT_BO_SUBSCRIPTION_LIST = 'HIT_BO_SUBSCRIPTION_LIST';
export const GET_BO_SUBSCRIPTION_LIST = 'GET_BO_SUBSCRIPTION_LIST';

// list user
export const HIT_BO_USER_LIST = 'HIT_BO_USER_LIST';
export const GET_BO_USER_LIST = 'GET_BO_USER_LIST';

export const HIT_BO_USER_CREATE = 'HIT_BO_USER_CREATE';

export const HIT_BO_USER_UPDATE = 'HIT_BO_USER_UPDATE';

// list log
export const HIT_BO_LOG_LIST = 'HIT_BO_LOG_LIST';
export const GET_BO_LOG_LIST = 'GET_BO_LOG_LIST';

export const HIT_BO_LOG_LIST_FEATURE = 'HIT_BO_LOG_LIST_FEATURE';
export const GET_BO_LOG_LIST_FEATURE = 'GET_BO_LOG_LIST_FEATURE';

export const HIT_BO_FILTER_LIST_LOG = 'HIT_BO_FILTER_LIST_LOG';

// list dashboard
export const HIT_BO_DASHBOARD = 'HIT_BO_DASHBOARD';
export const GET_BO_DASHBOARD = 'GET_BO_DASHBOARD';

// list feature
export const HIT_BO_FEATURE = 'HIT_BO_FEATURE';
export const GET_BO_FEATURE = 'GET_BO_FEATURE';

// pricing create
export const HIT_BO_SUBS_CREATE = 'HIT_BO_SUBS_CREATE';

// pricing update
export const HIT_BO_SUBS_UPDATE = 'HIT_BO_SUBS_UPDATE';

// apqc
export const HIT_BO_APQC = 'HIT_BO_APQC';
export const GET_BO_APQC = 'GET_BO_APQC';

export const HIT_BO_APQC_LIB = 'HIT_BO_APQC_LIB';
export const GET_BO_APQC_LIB = 'GET_BO_APQC_LIB';

export const HIT_BO_APQC_UPDATE = 'HIT_BO_APQC_UPDATE';
export const HIT_BO_APQC_UPDATE_LIBRARY = 'HIT_BO_APQC_UPDATE_LIBRARY';

export const HIT_BO_APQC_CREATE = 'HIT_BO_APQC_CREATE';

export const HIT_BO_APQC_MOVE = 'HIT_BO_APQC_MOVE';

export const HIT_BO_APQC_IMPORT = 'HIT_BO_APQC_IMPORT';

// workload
export const HIT_WORKLOAD_LIST = 'HIT_WORKLOAD_LIST';
export const GET_WORKLOAD_LIST = 'GET_WORKLOAD_LIST';

// competency
export const HIT_COMPETENCY_CREATE = 'HIT_COMPETENCY_CREATE';
export const HIT_COMPETENCY_UPDATE = 'HIT_COMPETENCY_UPDATE';
export const GET_COMPETENCY = 'GET_COMPETENCY';
export const HIT_COMPETENCY = 'HIT_COMPETENCY';

// Company-CompSetting
export const HIT_BO_CATEGORY_GROUP = 'HIT_BO_CATEGORY_GROUP';
export const GET_BO_CATEGORY_GROUP = 'GET_BO_CATEGORY_GROUP';

export const HIT_BO_CLASSIFICATION = 'HIT_BO_CLASSIFICATION';
export const GET_BO_CLASSIFICATION = 'GET_BO_CLASSIFICATION';

export const HIT_BO_ACTIVITY_TYPE = 'HIT_BO_ACTIVITY_TYPE';
export const GET_BO_ACTIVITY_TYPE = 'GET_BO_ACTIVITY_TYPE';

export const HIT_BO_COMPETENCY_LIBRARY = 'HIT_BO_COMPETENCY_LIBRARY';
export const GET_BO_COMPETENCY_LIBRARY = 'GET_BO_COMPETENCY_LIBRARY';

export const HIT_BO_CUSTOM_ORG_PARAMETER = 'HIT_BO_CUSTOM_ORG_PARAMETER';
export const GET_BO_CUSTOM_ORG_PARAMETER = 'GET_BO_CUSTOM_ORG_PARAMETER';

export const HIT_BO_DIRECTORATE = 'HIT_BO_DIRECTORATE';
export const GET_BO_DIRECTORATE = 'GET_BO_DIRECTORATE';

export const HIT_BO_FTE = 'HIT_BO_FTE';
export const GET_BO_FTE = 'GET_BO_FTE';

export const HIT_BO_LEVEL_DESCRIPTION = 'HIT_BO_LEVEL_DESCRIPTION';
export const GET_BO_LEVEL_DESCRIPTION = 'GET_BO_LEVEL_DESCRIPTION';

export const HIT_BO_MEMBER = 'HIT_BO_MEMBER';
export const GET_BO_MEMBER = 'GET_BO_MEMBER';

export const HIT_BO_REGION = 'HIT_BO_REGION';
export const GET_BO_REGION = 'GET_BO_REGION';

export const HIT_BO_SKILL_GROUP = 'HIT_BO_SKILL_GROUP';
export const GET_BO_SKILL_GROUP = 'GET_BO_SKILL_GROUP';

export const HIT_BO_SUB_SKILL_GROUP = 'HIT_BO_SUB_SKILL_GROUP';
export const GET_BO_SUB_SKILL_GROUP = 'GET_BO_SUB_SKILL_GROUP';

export const HIT_BO_WORKER_TYPE = 'HIT_BO_WORKER_TYPE';
export const GET_BO_WORKER_TYPE = 'GET_BO_WORKER_TYPE';

// Company-Board
export const HIT_BO_COMPANY_BOARD = 'HIT_BO_COMPANY_BOARD';
export const GET_BO_COMPANY_BOARD = 'GET_BO_COMPANY_BOARD';
export const HIT_BO_UPDATE_BOARD = 'HIT_BO_UPDATE_BOARD';

export const HIT_BO_BOARD_PROCESS = 'HIT_BO_BOARD_PROCESS';
export const GET_BO_BOARD_PROCESS = 'GET_BO_BOARD_PROCESS';

export const HIT_BO_BOARD_STRUCTURE = 'HIT_BO_BOARD_STRUCTURE';
export const GET_BO_BOARD_STRUCTURE = 'GET_BO_BOARD_STRUCTURE';

export const HIT_BO_CREATE_STRUCTURE = 'HIT_BO_CREATE_STRUCTURE';
export const HIT_BO_UPDATE_STRUCTURE = 'HIT_BO_UPDATE_STRUCTURE';
export const HIT_BO_IMPORT_ADD_ORGANIZATION = 'HIT_BO_IMPORT_ADD_ORGANIZATION';
export const HIT_BO_IMPORT_UPDATE_STRUCTURE = 'HIT_BO_IMPORT_UPDATE_STRUCTURE';
export const HIT_BO_IMPORT_UPDATE_EMPLOYEE = 'HIT_BO_IMPORT_UPDATE_EMPLOYEE';
export const HIT_BO_IMPORT_ANOTHER_BOARD_STRUCTURE = 'HIT_BO_IMPORT_ANOTHER_BOARD_STRUCTURE';
export const HIT_BO_IMPORT_ANOTHER_BOARD_EMPLOYEE = 'HIT_BO_IMPORT_ANOTHER_BOARD_EMPLOYEE';

export const HIT_BO_JOB_LEVEL = 'HIT_BO_JOB_LEVEL';
export const GET_BO_JOB_LEVEL = 'GET_BO_JOB_LEVEL';

export const HIT_BO_COMPETENCY_SKILL_GROUP = 'HIT_BO_COMPETENCY_SKILL_GROUP';
export const GET_BO_COMPETENCY_SKILL_GROUP = 'GET_BO_COMPETENCY_SKILL_GROUP';

export const HIT_BO_COMPETENCY_SUB_SKILL_GROUP = 'HIT_BO_COMPETENCY_SUB_SKILL_GROUP';
export const GET_BO_COMPETENCY_SUB_SKILL_GROUP = 'GET_BO_COMPETENCY_SUB_SKILL_GROUP';

export const HIT_BO_COMPETENCY_DETAIL = 'HIT_BO_COMPETENCY_DETAIL';
export const GET_BO_COMPETENCY_DETAIL = 'GET_BO_COMPETENCY_DETAIL';

export const HIT_BO_DETAIL_STRUCTURE = 'HIT_BO_DETAIL_STRUCTURE';
export const GET_BO_DETAIL_STRUCTURE = 'GET_BO_DETAIL_STRUCTURE';

export const HIT_BO_BOARD_EMPLOYEE = 'HIT_BO_BOARD_EMPLOYEE';
export const GET_BO_BOARD_EMPLOYEE = 'GET_BO_BOARD_EMPLOYEE';

export const HIT_BO_UPDATE_EMPLOYEE = 'HIT_BO_UPDATE_EMPLOYEE';
export const EXPORT_BO_STRUCTURE_REQUEST = 'EXPORT_BO_STRUCTURE_REQUEST';
export const EXPORT_BO_STRUCTURE_SUCCESS = 'EXPORT_BO_STRUCTURE_SUCCESS';

export const EXPORT_BO_EMPLOYEE_REQUEST = 'EXPORT_BO_EMPLOYEE_REQUEST';
export const EXPORT_BO_EMPLOYEE_SUCCESS = 'EXPORT_BO_EMPLOYEE_SUCCESS';

export const HIT_BO_BOARD_JOBDESC = 'HIT_BO_BOARD_JOBDESC';
export const GET_BO_BOARD_JOBDESC = 'GET_BO_BOARD_JOBDESC';
